import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useState } from "react";
import api from "../../../api/api";
import { useNavigate } from "react-router-dom";
import "./AuthPage.css";

const ForgotPasswordPage = () => {
  const navigate = useNavigate();
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const initialValues = { email: "" };

  const validationSchema = Yup.object({
    email: Yup.string().email("Invalid email").required("Email is required"),
  });

  const onSubmit = async (values, { setSubmitting }) => {
    try {
      console.log("Sending forgot password request for:", values.email);
      const response = await api.post("/auth/forgot-password", { email: values.email });
      console.log("Response received:", response);
      setIsModalOpen(true);
      setErrorMessage("");
    } catch (error) {
      console.error("Forgot password error:", error);
      setErrorMessage(
        error.response?.data?.message || "Something went wrong. Try again."
      );
      setSuccessMessage("");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-container forgot-password-page">
      <div
        className="forgot-password-card p-4 shadow rounded bg-white"
        style={{ width: "100%", maxWidth: "400px" }}
      >
        <div className="text-center mb-4">
          <h3>Forgot Password</h3>
          <p className="text-muted">
            Enter your email address and we'll send you a password reset link.
          </p>
        </div>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({ isSubmitting }) => (
            <Form>
              <div className="mb-3">
                <label className="form-label" htmlFor="email">
                  Email
                </label>
                <Field
                  type="email"
                  name="email"
                  className="form-control"
                  placeholder="Enter your email"
                />
                <ErrorMessage
                  name="email"
                  component="div"
                  className="invalid-feedback d-block"
                />
              </div>

              {errorMessage && (
                <div className="alert alert-danger">{errorMessage}</div>
              )}

              <button
                type="submit"
                className="btn btn-primary w-100"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Sending...
                  </>
                ) : (
                  "Send Reset Link"
                )}
              </button>
            </Form>
          )}
        </Formik>
        <div className="mt-3 text-center">
          <button className="btn btn-link" onClick={() => navigate("/login")}>
            Back to Login
          </button>
        </div>
      </div>

      {/* Success Modal */}
      {isModalOpen && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-body text-center">
                <p>The password reset email has been sent successfully.</p>
              </div>
              <div className="modal-footer justify-content-center">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    setIsModalOpen(false);
                    navigate("/login");
                  }}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ForgotPasswordPage;
